export default __webpack_public_path__ + "static/media/Kaleidoscope.80559c00.png";